<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefOrderList' }">
          待办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <do-it-action-box v-if="baseInfo" :base-info="baseInfo" />
    <base-info :document-i-d="documentID" @initedBaseInfo="initedBaseInfo" />
    <product v-if="baseInfo" :document-i-d="documentID" :base-info="baseInfo" />
  </div>
</template>
<script type="es6">
import baseInfo from '../baseInfo';
import doItActionBox from './doItActionBox';
import product from './product';
export default {
  data () {
    return {
      baseInfo: null
    };
  },
  components: {
    baseInfo,
    doItActionBox,
    product
  },
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  computed: {},
  methods: {
    initedBaseInfo (val) {
      this.baseInfo = val;
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss"></style>
